import React, { useMemo, useState } from 'react';


function RoundField(props) {
  const [descriptionIsShown, SetDescriptionShown] = useState(props.forceShowHistData || false);
  const [varNameShown, SetVarNameShown] = useState(false);
  const [histDataShown, SetHistDataShown] = useState(props.forceShowHistData || false);


  const advancedFunctionButtonsM = useMemo(AdvancedFunctionButtons,
    [varNameShown, histDataShown, props.historicDataComponent, props.varName]);
  function AdvancedFunctionButtons() {
    let histDataButton = null;
    let varNameButton = (<button
      className='Advanced ShowVarName'
      onClick={() => SetVarNameShown(!varNameShown)}
    >
      show contract name
    </button>);
    if (props.varName == 'ignore')
      varNameButton = null;
    if (props.historicDataComponent)
      histDataButton = (<button
        className='Advanced ShowHistData PulsateGreen'
        onClick={() => SetHistDataShown(!histDataShown)}
      >
        verify
      </button>);
    return (<div className='AdvancedFunctionButtons'>
      {histDataButton}
      {varNameButton}
    </div>);
  }

  const varNameM = useMemo(VarName, [varNameShown, props.varName]);
  function VarName() {
    if (!props.varName && varNameShown)
      return (<div className='ContractVarName'><p className='VarName'>
        This value is not directly stored in the smart contract and is shown here for your convenience.
      </p></div>)
    else if (props.varName == 'ignore' && varNameShown)
      return null;
    else if (varNameShown)
      return (<div className='ContractVarName'>
        <p className='VarName'>Known as <span>{props.varName}</span> in the contract</p>
      </div>);
    else
      return null;
  }

  const historicDataM = useMemo(HistoricData, [histDataShown, props.historicDataComponent]);
  function HistoricData() {
    if (!props.historicDataComponent)
      return null;
    else if (histDataShown)
      return props.historicDataComponent;
    else
      return null;
  }


  return (<div className='Field' id={props.id || null}>
    <div className='BlockchainData'>
      <dt>{props.name}</dt>
      <dd>{props.value}</dd>
      <button
        className='ShowDescription'
        onClick={() => SetDescriptionShown(!descriptionIsShown)}
      >
        ?
      </button>
    </div>
    {descriptionIsShown ? (
      <dd className='Description'>
        {props.description}
        {advancedFunctionButtonsM}
        {varNameM}
        {historicDataM}
      </dd>
    ) : (
      null
    )}
  </div>);
}


export default RoundField;